export enum EventPriority {
  long,
  short,
}
